module.exports = {
  title: '拼团活动统计',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'statistics-spell-group-activity',
    },
  },
};
